import { memo } from "react";
import PropTypes from "prop-types";

import classNames from "./PreviewBaseItem.module.css";

interface IPreviewBaseItemProps {
  backgroundImage: string;
  backgroundSize?: string;
  contentHeight: number;
  contentWidth: number;
  iframeHeight: number | string;
  iframeWidth: number;
  iframeTop?: number;
  iframeLeft?: number;
  srcDoc: string;
  title: string;
}

function PreviewBaseItem({
  backgroundImage,
  backgroundSize = "100% 100%",
  contentHeight,
  contentWidth,
  iframeHeight,
  iframeWidth,
  iframeTop,
  iframeLeft,
  title,
  srcDoc,
}: IPreviewBaseItemProps) {
  return (
    <div className={classNames.container}>
      <div
        style={{
          width: contentWidth,
          height: contentHeight,
          backgroundSize,
          backgroundRepeat: "no-repeat",
          backgroundImage: `url(${backgroundImage})`,
        }}
      >
        <iframe
          key={Math.random()}
          title={title}
          srcDoc={srcDoc}
          // target="_blank"
          style={{
            width: iframeWidth,
            height: iframeHeight,
            top: iframeTop,
            left: iframeLeft,
            border: 0,
            backgroundColor: "#fff",
            position: "relative",
          }}
        />
      </div>
    </div>
  );
}

PreviewBaseItem.propTypes = {
  backgroundImage: PropTypes.string.isRequired,
  backgroundSize: PropTypes.string,
  contentHeight: PropTypes.number.isRequired,
  contentWidth: PropTypes.number.isRequired,
  iframeHeight: PropTypes.number.isRequired,
  iframeWidth: PropTypes.number.isRequired,
  iframeTop: PropTypes.number,
  iframeLeft: PropTypes.number,
  srcDoc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
export default memo(PreviewBaseItem);
